/**
 * Fellheimat - Mengenstaffel: Auswahl umsetzen und in den Warenkorb legen
 *
 * Gehoert zu blocks/fh-volume-tiers.liquid. Das Markup steht dort, hier steht
 * nur das Verhalten: Optionen aufklappen, Varianten je Stueck aufloesen und
 * den Add-to-Cart-Request von Horizon so ergaenzen, dass alle gewaehlten
 * Geschirre in einem einzigen Request im Warenkorb landen.
 *
 * WARUM DER REQUEST VON HORIZON ERGAENZT UND NICHT ERSETZT WIRD
 * Horizon schickt beim Add-to-Cart
 *     POST /cart/add.js   Accept: text/html
 *     FormData: form_type, utf8, id, quantity, product-id, section-id,
 *               sections=cart-drawer-section
 * und laesst sich den fertigen Cart Drawer im selben Response mitliefern.
 * Ein zweiter, eigener Request wuerde entweder einen veralteten Drawer zeigen
 * oder eine zweite Netzwerkrunde kosten. Gemessen am 25.08.2026: /cart/add.js
 * nimmt neben id/quantity zusaetzlich items[N][id] / items[N][quantity] /
 * items[N][properties][...] in derselben FormData an.
 *
 * WARUM quantity AUF 0 GESETZT WIRD
 * id und items[] werden beide verarbeitet - stehen beide, landet das Geschirr
 * doppelt im Warenkorb (gemessen). quantity=0 auf der obersten Ebene ist ein
 * Leerlauf: Shopify legt dafuer nichts an, meldet keinen Fehler, und das Feld
 * id bleibt erhalten. Das ist noetig, weil Horizons Erfolgspfad nach der
 * Antwort formData.get('id') liest und ohne diesen Wert
 * "Form ID is required" wirft - der Drawer wuerde sich dann nicht aktualisieren.
 *
 * WARUM DIE STUECKE IN UMGEKEHRTER REIHENFOLGE GESENDET WERDEN
 * Gemessen am 25.08.2026: Shopify legt die Positionen eines items[]-Stapels in
 * umgekehrter Reihenfolge im Warenkorb ab - und zwar nach der Reihenfolge, in
 * der die Felder im Body STEHEN, nicht nach der Zahl in items[N]. Der erste
 * Gegentest mit aufsteigenden Indizes sah noch nach Index-Umkehr aus; erst der
 * zweite Lauf mit absteigend angehaengten Indizes hat den Unterschied gezeigt.
 * Deshalb wird das Stueck aus dem Standard-Selektor ZULETZT angehaengt - dann
 * steht es im Warenkorb oben, in derselben Reihenfolge, die der Kunde auf der
 * Produktseite gewaehlt hat. Daran haengt auch die Farbe der Gratis-Leine bei
 * gemischten Farben (snippets/fh-gift-config, Regel 3).
 *
 * GLEICHE VARIANTEN WERDEN ZUSAMMENGEFASST
 * Drei gleiche Geschirre gehen als EINE Position mit Menge 3 raus, nicht als
 * drei Positionen. Das ist kein Schoenheitsfehler: CJ-Dropshipping behandelt
 * jede zusaetzliche Bestellposition als eigenen Versand (siehe Bestellung
 * #1003). Nur wirklich verschiedene Varianten muessen getrennt stehen.
 *
 * DIE AUSWAHL JE STUECK LAEUFT UEBER <select>
 * Auf Ansage des Betreibers vom 25.08.2026: Farbe und Groesse als zwei
 * Dropdowns in einer Zeile statt als Swatch- und Groessen-Pillen. Nicht
 * kombinierbare Werte werden gesperrt statt entfernt, und passt die zweite
 * Option nicht mehr zur eben gewaehlten, zieht resolve() sie auf den ersten
 * verfuegbaren Wert - sonst koennte der Kunde in einer Kombination landen,
 * die es nicht gibt, und der Add-to-Cart liesse das Stueck stillschweigend weg.
 *
 * DIE GESCHENK-PROPERTY SETZT DIESES SKRIPT NICHT
 * Sie ist Sache von assets/fh-free-gift.js. Dessen reconcile() laeuft nach
 * jedem Warenkorb-Schreibvorgang und traegt sie an genau einer Zeile nach.
 */
(function () {
  'use strict';

  var DATA = window.FH_VOLUME_TIERS;
  if (!DATA) return;

  var CART_ADD = /\/cart\/add(\.js)?/;
  var nativeFetch = window.fetch.bind(window);

  /* --- Varianten aufloesen -------------------------------------------------- */

  function findVariant(cfg, values) {
    for (var i = 0; i < cfg.variants.length; i++) {
      var v = cfg.variants[i];
      var hit = true;
      for (var k = 0; k < values.length; k++) {
        if (v.o[k] !== values[k]) {
          hit = false;
          break;
        }
      }
      if (hit) return v;
    }
    return null;
  }

  /* Gibt es zu diesem Wert an Position k eine verfuegbare Variante, wenn alle
     ANDEREN gewaehlten Werte bestehen bleiben? */
  function valueAvailable(cfg, values, k, candidate) {
    for (var i = 0; i < cfg.variants.length; i++) {
      var v = cfg.variants[i];
      if (!v.a) continue;
      if (v.o[k] !== candidate) continue;
      var hit = true;
      for (var j = 0; j < values.length; j++) {
        if (j !== k && v.o[j] !== values[j]) {
          hit = false;
          break;
        }
      }
      if (hit) return true;
    }
    return false;
  }

  /* --- Eine Stueck-Einheit -------------------------------------------------- */

  function Unit(el, cfg) {
    this.el = el;
    this.cfg = cfg;
    this.touched = false;
    this.selects = Array.prototype.slice.call(el.querySelectorAll('.fh-vt__select'));
    this.thumb = el.querySelector('[data-fh-thumb]');
    this.values = [];
    this.variantId = null;

    var self = this;
    this.selects.forEach(function (select, k) {
      select.addEventListener('change', function () {
        self.touched = true;
        self.values[k] = select.value;
        self.resolve(k);
      });
    });
  }

  /* Uebernimmt die Werte der Hauptvariante, solange der Kunde diese Einheit
     noch nicht selbst angefasst hat. So steht beim Aufklappen bereits die
     Kombination drin, die oben im Standard-Selektor gewaehlt ist. */
  Unit.prototype.syncFrom = function (values) {
    if (this.touched || !values) return;
    this.values = values.slice();
    this.resolve(-1);
  };

  /**
   * Setzt Zustand, Verfuegbarkeiten und Bild neu.
   * @param {number} changed - Index der zuletzt geaenderten Option, -1 fuer alle.
   */
  Unit.prototype.resolve = function (changed) {
    var cfg = this.cfg;
    var self = this;

    /* Sackgassen vermeiden: passt eine andere Option nicht mehr zur eben
       gewaehlten, wird sie auf den ersten verfuegbaren Wert gezogen, statt den
       Kunden in einer unmoeglichen Kombination stehen zu lassen. */
    this.selects.forEach(function (select, k) {
      if (k === changed) return;
      if (valueAvailable(cfg, self.values, k, self.values[k])) return;
      for (var i = 0; i < select.options.length; i++) {
        if (valueAvailable(cfg, self.values, k, select.options[i].value)) {
          self.values[k] = select.options[i].value;
          return;
        }
      }
    });

    /* Nicht kombinierbare Werte bleiben sichtbar, aber gesperrt - ein Kunde
       soll sehen, dass es die Farbe gibt, nur eben nicht in dieser Groesse. */
    this.selects.forEach(function (select, k) {
      for (var i = 0; i < select.options.length; i++) {
        var opt = select.options[i];
        opt.disabled = !valueAvailable(cfg, self.values, k, opt.value);
      }
      select.value = self.values[k];
    });

    var variant = findVariant(cfg, this.values);
    this.variantId = variant && variant.a ? variant.i : null;

    if (this.thumb && variant && variant.m) this.thumb.src = variant.m;

    var note = this.el.querySelector('.fh-vt__unit-note');
    if (!this.variantId) {
      if (!note) {
        note = document.createElement('p');
        note.className = 'fh-vt__unit-note';
        this.el.appendChild(note);
      }
      note.textContent = cfg.soldOutNote;
    } else if (note) {
      note.remove();
    }
  };

  /* --- Ein Staffel-Block ---------------------------------------------------- */

  function Tiers(root) {
    var productId = root.dataset.productId;
    var cfg = DATA[productId];
    if (!cfg) return;

    this.root = root;
    this.cfg = cfg;
    this.productId = String(productId);
    this.units = [];

    var self = this;
    Array.prototype.slice.call(root.querySelectorAll('.fh-vt__unit')).forEach(function (el) {
      self.units.push(new Unit(el, cfg));
    });

    root.addEventListener('change', function (event) {
      if (!event.target.classList.contains('fh-vt__radio')) return;
      self.apply();
    });

    /* Der Standard-Selektor sitzt ausserhalb dieses Blocks. Horizon morpht bei
       einem Variantenwechsel nur das <variant-picker> selbst, es gibt also
       kein Ereignis am Block - deshalb wird am Formular gelauscht. */
    var form = this.mainForm();
    if (form) {
      form.addEventListener('change', function () {
        self.syncUnits();
      });
    }

    this.apply();
  }

  Tiers.prototype.mainForm = function () {
    var pfc = document.querySelector('product-form-component[data-product-id="' + this.productId + '"]');
    return pfc ? pfc.querySelector('form') : null;
  };

  Tiers.prototype.mainValues = function () {
    var form = this.mainForm();
    var input = form && form.querySelector('input[name="id"]');
    if (!input) return null;
    for (var i = 0; i < this.cfg.variants.length; i++) {
      if (String(this.cfg.variants[i].i) === String(input.value)) return this.cfg.variants[i].o;
    }
    return null;
  };

  Tiers.prototype.selectedTier = function () {
    return this.root.querySelector('.fh-vt__radio:checked');
  };

  Tiers.prototype.quantity = function () {
    var radio = this.selectedTier();
    return radio ? Number(radio.dataset.qty) || 1 : 1;
  };

  Tiers.prototype.syncUnits = function () {
    var values = this.mainValues();
    this.units.forEach(function (unit) {
      unit.syncFrom(values);
    });
  };

  Tiers.prototype.apply = function () {
    var radio = this.selectedTier();
    var self = this;
    Array.prototype.slice.call(this.root.querySelectorAll('.fh-vt__tier')).forEach(function (tier) {
      var panel = tier.querySelector('[data-fh-units]');
      var active = radio && tier.dataset.fhTier === radio.value;
      tier.classList.toggle('is-selected', !!active);
      if (panel) panel.hidden = !active;
      if (active && panel) self.syncUnits();
    });
  };

  /* Varianten-IDs der Zusatzstuecke der gerade gewaehlten Option. */
  Tiers.prototype.extraVariantIds = function () {
    var radio = this.selectedTier();
    if (!radio) return [];
    var tier = this.root.querySelector('.fh-vt__tier[data-fh-tier="' + radio.value + '"]');
    if (!tier) return [];
    var ids = [];
    this.units.forEach(function (unit) {
      if (!tier.contains(unit.el)) return;
      if (unit.variantId) ids.push(String(unit.variantId));
    });
    return ids;
  };

  /* --- Registrierung -------------------------------------------------------- */

  var instances = [];

  function init() {
    document.querySelectorAll('[data-fh-vt]').forEach(function (root) {
      if (root.dataset.fhVtReady) return;
      root.dataset.fhVtReady = '1';
      var t = new Tiers(root);
      if (t.cfg) instances.push(t);
    });
  }

  function instanceFor(productId) {
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].productId === String(productId)) return instances[i];
    }
    return null;
  }

  /* --- Request umschreiben -------------------------------------------------- */

  function rewrite(body) {
    var productId = body.get('product-id');
    var mainId = body.get('id');
    if (!productId || !mainId) return;

    var tiers = instanceFor(productId);
    if (!tiers) return;

    var wanted = tiers.quantity();
    if (wanted <= 1) return;

    /* Reihenfolge wie auf der Produktseite: Stueck 1 aus dem Standard-Selektor,
       danach die Zusatzstuecke. */
    var units = [String(mainId)].concat(tiers.extraVariantIds());
    if (units.length < 2) return;

    /* Gleiche Varianten zusammenfassen, Reihenfolge des ersten Auftretens
       behalten. Eine Position weniger heisst bei CJ ein Versand weniger. */
    var order = [];
    var counts = {};
    units.forEach(function (id) {
      if (counts[id] === undefined) {
        counts[id] = 0;
        order.push(id);
      }
      counts[id] += 1;
    });

    if (order.length === 1) {
      body.set('quantity', String(counts[order[0]]));
      return;
    }

    body.set('quantity', '0');

    /* Rueckwaerts anhaengen: das letzte Stueck zuerst, das Stueck aus dem
       Standard-Selektor zuletzt. Der Warenkorb dreht die Anhaenge-Reihenfolge
       um und zeigt es dadurch oben. */
    for (var i = order.length - 1; i >= 0; i--) {
      var id = order[i];
      var slot = order.length - 1 - i;
      body.append('items[' + slot + '][id]', id);
      body.append('items[' + slot + '][quantity]', String(counts[id]));
    }
  }

  window.fetch = function (input, init) {
    var args = Array.prototype.slice.call(arguments);
    var url = typeof input === 'string' ? input : (input && input.url) || '';

    if (CART_ADD.test(url)) {
      var body = (init && init.body) || (input && input.body);
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        try {
          rewrite(body);
        } catch (e) {
          /* Im Zweifel unveraendert weiterreichen - dann liegt ein Geschirr im
             Warenkorb statt drei, statt gar keinem. */
        }
      }
    }

    return nativeFetch.apply(null, args);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Der Theme-Editor rendert Bloecke neu, ohne die Seite zu laden. */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
